import AbstractTextControl from "slotworks/smart-ui/controls/abstract/abstract-text-control";
import { Control } from "slotworks/smart-ui/controls/control";
import BetOptions from "slotworks/smart-ui/options/control-options";

export default class TotalCreditsTextControl extends AbstractTextControl implements Control {

    public updateOptions(betOptions: BetOptions) {
        this.text.setText(betOptions.getTotalCredits().toString());
    }
}
